import styled from 'styled-components';
import { Drawer, Text } from '@medly-components/core';

export const Header = styled(Drawer.Header)`
    display: flex;
    flex-direction: column;
    padding: 2.4rem 5.8rem 2.4rem 1.3rem;
`;

export const StationInfo = styled.div`
    display: flex;
    align-items: center;
`;

export const StationIconWrapper = styled.div`
    width: 3.2rem;
    height: 3.2rem;
    display: flex;
    align-items: center;
    margin-right: 1.6rem;
`;

export const StationText = styled.div`
    display: flex;
    flex: 1;
    flex-direction: column;
`;

export const LastUpdatedText = styled(Text)`
    margin-top: 0.8rem;
    margin-left: 4.8rem;
    color: ${({ theme }) => theme.colors.grey[700]};
`;
